import { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

type Route =
  'trail' | 'trails' | 'trail/new' | 'parks' | 'cities' | 'countries' | 'regions' | 'states' | 'national-parks' | 'state-parks' | 'local-parks';

const localizedPaths: Record<LanguageRegionCode, Record<Route, string>> = {
  'en-US': {
    trail: 'trail',
    trails: 'trails',
    'trail/new': 'trail/new',
    parks: 'parks',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'en-GB': {
    trail: 'trail',
    trails: 'trails',
    'trail/new': 'trail/new',
    parks: 'parks',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'da-DK': {
    trail: 'rute',
    trails: 'ruter',
    'trail/new': 'rute/new',
    parks: 'parker',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'de-DE': {
    trail: 'route',
    trails: 'route',
    'trail/new': 'route/neue',
    parks: 'parks',
    cities: 'staedte',
    countries: 'countries',
    regions: 'regionen',
    states: 'staaten',
    'national-parks': 'nationalparks',
    'state-parks': 'naturparks',
    'local-parks': 'regionale-parks'
  },
  'es-ES': {
    trail: 'ruta',
    trails: 'ruta',
    'trail/new': 'ruta/nueva',
    parks: 'parques',
    cities: 'ciudades',
    countries: 'countries',
    regions: 'regiones',
    states: 'estados',
    'national-parks': 'parques-nacionales',
    'state-parks': 'parques-naturales',
    'local-parks': 'parques-locales'
  },
  'es-MX': {
    trail: 'ruta',
    trails: 'senderos',
    'trail/new': 'ruta/nueva',
    parks: 'parques',
    cities: 'ciudades',
    countries: 'countries',
    regions: 'regiones',
    states: 'estados',
    'national-parks': 'parques-nacionales',
    'state-parks': 'parques-naturales',
    'local-parks': 'parques-locales'
  },
  'fr-FR': {
    trail: 'randonnee',
    trails: 'randonnee',
    'trail/new': 'randonnee/nouvelle',
    parks: 'parcs',
    cities: 'villes',
    countries: 'countries',
    regions: 'regions',
    states: 'etats',
    'national-parks': 'parcs-nationaux',
    'state-parks': 'parcs-naturels-regionaux',
    'local-parks': 'parcs-locaux'
  },
  'it-IT': {
    trail: 'sentiero',
    trails: 'sentieri',
    'trail/new': 'sentiero/new',
    parks: 'parchi',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'nl-NL': {
    trail: 'wandelpad',
    trails: 'routes',
    'trail/new': 'wandelpad/new',
    parks: 'parken',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'nb-NO': {
    trail: 'sti',
    trails: 'stier',
    'trail/new': 'sti/new',
    parks: 'parker',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'pl-PL': {
    trail: 'szlak',
    trails: 'szlaki',
    'trail/new': 'szlak/new',
    parks: 'parki',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'pt-BR': {
    trail: 'trilha',
    trails: 'trilhas',
    'trail/new': 'trilha/new',
    parks: 'parques',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'pt-PT': {
    trail: 'trilho',
    trails: 'trilhos',
    'trail/new': 'trilho/new',
    parks: 'parques',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  },
  'sv-SE': {
    trail: 'led',
    trails: 'leder',
    'trail/new': 'led/new',
    parks: 'parker',
    cities: 'cities',
    countries: 'countries',
    regions: 'regions',
    states: 'states',
    'national-parks': 'national-parks',
    'state-parks': 'state-parks',
    'local-parks': 'local-parks'
  }
};

export default localizedPaths;
